<template>
    <div>

        <config-main-title>
            Feriados
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-3">
                    <az-input 
                        icon="fas fa-calendar" 
                        type="select"
                        optionsMode="json"
                        optionsData="id"
                        optionsDisplay="search"
                        :optionsList="anos"
                        v-model="ano" 
                        @input="load ()" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Feriado
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum feriado identificado.'" 
                icon="fas fa-search"
                :action="'Incluir Feriado'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                        <span v-if="dado.fl_recorrente" class="text-muted mr-3"
                            data-toggle="tooltip" data-placement="top" title="Recorrente"> 
                            <i class="fas fa-sync"></i>
                        </span>

                        <span class="badge badge-secondary mr-3" v-if="dado.abrangencia">
                            {{ dado.abrangencia }}
                        </span>

                        <span v-if="dado.ch_abrangencia == 'E' && dado.estado">
                            {{ dado.estado.search }}
                        </span>

                        <span v-if="dado.ch_abrangencia == 'M' && dado.cidade">
                            {{ dado.cidade.search }}
                        </span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_agenda_feriado ? '' : 'Novo' }}
                            Feriado
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Descrição"
                                    :validate="validate"
                                    required
                                    v-model="item.st_descricao" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Abrangência"
                                    type="select"
                                    :validate="validate"
                                    required
                                    :optionsList="[
                                        { id: 'F', search: 'Federal' },
                                        { id: 'E', search: 'Estadual' },
                                        { id: 'M', search: 'Municipal' },
                                    ]"
                                    optionsData="id"
                                    v-model="item.ch_abrangencia" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <!-- Estado -->
                                <az-input
                                    v-if="item.ch_abrangencia == 'E'"
                                    label="Estado"
                                    type="select" optionsMode="aql" 
                                    service="estados.index" 
                                    optionsData="id_estado" 
                                    optionsDisplay="st_estado"
                                    required
                                    v-model="item.id_estado" />

                                <!-- Cidade -->
                                <az-input
                                    v-if="item.ch_abrangencia == 'M'"
                                    label="Cidade"
                                    type="autocomplete" 
                                    optionsMode="aql" 
                                    service="cidades.index" 
                                    optionsData="id_cidade" 
                                    optionsDisplay="search"
                                    :optionsParm="{ uf: '%' }"
                                    required
                                    v-model="item.id_cidade" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="De"
                                    type="date"
                                    :validate="validate"
                                    required
                                    v-model="item.dt_inicio" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Horário"
                                    type="time"
                                    :validate="validate"
                                    required
                                    v-model="item.hora_inicio" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Até"
                                    type="date"
                                    :validate="validate"
                                    required
                                    v-model="item.dt_termino" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Horário"
                                    type="time"
                                    :validate="validate"
                                    required
                                    v-model="item.hora_termino" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <div class="input-group my-3">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">
                                            <input type="checkbox" v-model="item.fl_recorrente">
                                        </div>
                                    </div>
                                    <input type="text" class="form-control" placeholder="Replicar Anualmente" disabled>
                                </div>
                            </div>

                            <div class="col col-12 col-md-6">
                                <div class="input-group my-3">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">
                                            <input type="checkbox" v-model="item.fl_pode_agendar">
                                        </div>
                                    </div>
                                    <input type="text" class="form-control" placeholder="Permitir Agendar" disabled>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button v-if="item.id_agenda_feriado" :id="item.id_agenda_feriado" model="agendaFeriado" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            metadados: null, 
            anos: []
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit, 
        AzAuditLogButton
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                })
                .sort((a, b) => { 
                    return a.dt_inicio.substr(5,5) > b.dt_inicio.substr(5,5) ? 1 : -1 ;
                }) : null;
        }
    },

    methods: { 
        incluir () { 
            this.validate = false;

            let item = {
                id_agenda_feriado: null, 
                st_descricao: "", 
                dt_inicio: null, 
                dt_termino: null, 
                hora_inicio: "00:00",
                hora_termino: "23:59",
                fl_recorrente: true,
                ch_abrangencia: "F",
                id_estado: "",
                id_cidade: "", 
                fl_pode_agendar: false, 
            };

            this.editar (item);
        },
        load () { 
            this.$store.commit('loading', true);

            let query = { q: [
                { 
                    name: 'agenda_feriados.index',
                    id: 'lista',
                    parms: { 
                        ano: this.ano, 
                        cadastro: true, 
                    }
                },
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.lista.status == 200 ) { 
                        this.dados = res.data.lista.data;
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });
        },
        editar (item) { 
            this.item = null;

            this.$nextTick(() => { 
                this.validate = false;
                this.item = _.cloneDeep (item);
                $('#edicaoModal').modal('show');
            });
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'agenda_feriados',
                func: 'store',
                dados: this.item,
                modal: 'edicaoModal',
                reload: true, 
            });
            
        },
        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$store.commit('loading', true);

            let query = { q: [ 
                { 
                    name: 'agenda_feriados.toggle',
                    id: 'toggle',
                    parms: { 
                        ...item,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.toggle.status == 200 ) { 
                        //
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    created () { 
        let esteAno = new Date ().getFullYear();

        this.ano = esteAno;

        this.anos = [ 
            { id: esteAno - 1, search: esteAno - 1 },
            { id: esteAno, search: esteAno },
            { id: esteAno + 1, search: esteAno + 1 },
        ];
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Feriados", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>